var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "6" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "6" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "FieldAnalysis" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    { attrs: { "item-key": "Code", error: _vm.$v.form.Code } },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Code
                        },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: {
                          type: "number",
                          toggle: "",
                          disabled: _vm.insertReadonly.StatusId
                        },
                        model: {
                          value: _vm.form.StatusId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "StatusId", $$v)
                          },
                          expression: "form.StatusId"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.fieldAnalysis.title"),
                    active: ""
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.tabValidation()
                    }
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ValidityTypeId",
                            error: _vm.$v.form.ValidityTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.ValidityTypeId,
                              "lookup-key": "ANALYSIS_VALIDITY_TYPE"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "ValidityTypeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.validityType,
                              callback: function($$v) {
                                _vm.validityType = $$v
                              },
                              expression: "validityType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "AnalysisTypeId",
                            error: _vm.$v.form.AnalysisTypeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.AnalysisTypeId,
                              "lookup-key": "FIELD_ANALYSIS_TYPE"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "AnalysisTypeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.analysisType,
                              callback: function($$v) {
                                _vm.analysisType = $$v
                              },
                              expression: "analysisType"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "AnalysisPeriodId",
                            error: _vm.$v.form.AnalysisPeriodId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.AnalysisPeriodId,
                              "lookup-key": "ANALYSIS_PERIOD"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "AnalysisPeriodId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.analysisPeriod,
                              callback: function($$v) {
                                _vm.analysisPeriod = $$v
                              },
                              expression: "analysisPeriod"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "ApproveStateId",
                            error: _vm.$v.form.ApproveStateId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: { disabled: true, label: "Label" },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "ApproveStateId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.approveState,
                              callback: function($$v) {
                                _vm.approveState = $$v
                              },
                              expression: "approveState"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "AnalysisVisitCount",
                            error: _vm.$v.form.AnalysisVisitCount
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              disabled: _vm.insertReadonly.AnalysisVisitCount
                            },
                            model: {
                              value: _vm.form.AnalysisVisitCount,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "AnalysisVisitCount", $$v)
                              },
                              expression: "form.AnalysisVisitCount"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "CustomerCriteriaId",
                            error: _vm.$v.form.CustomerCriteriaId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.CustomerCriteriaId,
                              source: _vm.lookup.CUSTOMER_CRITERIA,
                              label: "Label"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "CustomerCriteriaId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.customerCriteria,
                              callback: function($$v) {
                                _vm.customerCriteria = $$v
                              },
                              expression: "customerCriteria"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "IsNecessary",
                            error: _vm.$v.form.IsNecessary
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled: true
                            },
                            model: {
                              value: _vm.form.IsNecessary,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "IsNecessary", $$v)
                              },
                              expression: "form.IsNecessary"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "UseOnce",
                            error: _vm.$v.form.UseOnce
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled:
                                !_vm.analysisType ||
                                _vm.analysisType.Code !== "KLN"
                            },
                            model: {
                              value: _vm.form.UseOnce,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "UseOnce", $$v)
                              },
                              expression: "form.UseOnce"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "SortOrder",
                            error: _vm.$v.form.SortOrder
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: {
                              type: "number",
                              disabled: _vm.insertReadonly.SortOrder,
                              maxLength: "2",
                              oninput: _vm.maxLengthControl
                            },
                            model: {
                              value: _vm.form.SortOrder,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "SortOrder", $$v)
                              },
                              expression: "form.SortOrder"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "AnalysisTimeId",
                            error: _vm.$v.form.AnalysisTimeId
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: _vm.insertReadonly.AnalysisTimeId,
                              "lookup-key": "ANALYSIS_TIME"
                            },
                            on: {
                              input: function($event) {
                                return _vm.selectedType(
                                  "AnalysisTimeId",
                                  $event
                                )
                              }
                            },
                            model: {
                              value: _vm.analysisTime,
                              callback: function($$v) {
                                _vm.analysisTime = $$v
                              },
                              expression: "analysisTime"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            "item-key": "FollowingAnalysis",
                            error: _vm.$v.form.FollowingAnalysis
                          }
                        },
                        [
                          _c("NextCheckBox", {
                            attrs: {
                              type: "number",
                              toggle: "",
                              disabled: _vm.insertReadonly.FollowingAnalysis
                            },
                            model: {
                              value: _vm.form.FollowingAnalysis,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "FollowingAnalysis", $$v)
                              },
                              expression: "form.FollowingAnalysis"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("insert.fieldAnalysis.question") } },
                [
                  _c(
                    "NextDetailPanel",
                    {
                      attrs: {
                        items: _vm.fieldAnalysisQuestionItems,
                        "has-line-number": true
                      },
                      model: {
                        value: _vm.form.FieldAnalysisQuestions,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "FieldAnalysisQuestions", $$v)
                        },
                        expression: "form.FieldAnalysisQuestions"
                      }
                    },
                    [
                      _c("template", { slot: "grid" }, [
                        _c(
                          "div",
                          { attrs: { cols: "12", md: "2" } },
                          [
                            _c("NextMultipleSelection", {
                              attrs: {
                                name: "FieldAnalysisMultipleQuestion",
                                "hidden-values": _vm.hiddenValuesQuestion,
                                "converted-values":
                                  _vm.convertedValuesQuestions,
                                "initial-values-func":
                                  _vm.questionsInitialValues
                              },
                              model: {
                                value: _vm.form.FieldAnalysisQuestions,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "FieldAnalysisQuestions",
                                    $$v
                                  )
                                },
                                expression: "form.FieldAnalysisQuestions"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("insert.fieldAnalysis.branchs") } },
                [
                  _c(
                    "NextDetailPanel",
                    {
                      attrs: { items: _vm.fieldAnalysisBranchItems },
                      model: {
                        value: _vm.form.FieldAnalysisBranchs,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "FieldAnalysisBranchs", $$v)
                        },
                        expression: "form.FieldAnalysisBranchs"
                      }
                    },
                    [
                      _c("template", { slot: "grid" }, [
                        _c(
                          "div",
                          { attrs: { cols: "12", md: "2" } },
                          [
                            _c("NextMultipleSelection", {
                              attrs: {
                                name: "FieldAnalysisMultipleBranch",
                                "hidden-values": _vm.hiddenValuesBranch,
                                "initial-values-func": _vm.branchsInitialValues
                              },
                              model: {
                                value: _vm.form.FieldAnalysisBranchs,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form,
                                    "FieldAnalysisBranchs",
                                    $$v
                                  )
                                },
                                expression: "form.FieldAnalysisBranchs"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: { title: _vm.$t("insert.fieldAnalysis.employeeType") }
                },
                [
                  _c("NextDetailPanel", {
                    attrs: { items: _vm.fieldAnalysisEmployeeItems },
                    model: {
                      value: _vm.form.FieldAnalysisEmployeeTypes,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "FieldAnalysisEmployeeTypes", $$v)
                      },
                      expression: "form.FieldAnalysisEmployeeTypes"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.validityType && _vm.validityType.Code === "SS"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.fieldAnalysis.validDates")
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: {
                          items: _vm.fieldAnalysisValidDateItems,
                          "before-add": _vm.beforeValidDatesAdd
                        },
                        model: {
                          value: _vm.form.FieldAnalysisValidDates,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "FieldAnalysisValidDates", $$v)
                          },
                          expression: "form.FieldAnalysisValidDates"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.customerCriteria && _vm.customerCriteria.Code === "ML"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.fieldAnalysis.customerList"),
                        disabled:
                          !_vm.form.FieldAnalysisBranchs ||
                          _vm.form.FieldAnalysisBranchs.length === 0
                      }
                    },
                    [
                      _c(
                        "NextDetailPanel",
                        {
                          attrs: { items: _vm.getFieldAnalysisCustomerItems() },
                          model: {
                            value: _vm.customers,
                            callback: function($$v) {
                              _vm.customers = $$v
                            },
                            expression: "customers"
                          }
                        },
                        [
                          _c("template", { slot: "grid" }, [
                            _c(
                              "div",
                              { attrs: { cols: "12", md: "2" } },
                              [
                                _c("NextMultipleSelection", {
                                  attrs: {
                                    name: "FieldAnalysisMultipleCustomer",
                                    "hidden-values": _vm.hiddenValues,
                                    "dynamic-and-condition": {
                                      BranchIds: this.form.FieldAnalysisBranchs.map(
                                        function(f) {
                                          return f.AnalysisBranchId
                                        }
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.customers,
                                    callback: function($$v) {
                                      _vm.customers = $$v
                                    },
                                    expression: "customers"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.customerCriteria && _vm.customerCriteria.Code === "MK"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.fieldAnalysis.customerCriterias")
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.fieldAnalysisDetailItems },
                        model: {
                          value: _vm.customerCriterias,
                          callback: function($$v) {
                            _vm.customerCriterias = $$v
                          },
                          expression: "customerCriterias"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.customerCriteria && _vm.customerCriteria.Code === "MS"
                ? _c(
                    "b-tab",
                    {
                      attrs: {
                        lazy: "",
                        title: _vm.$t("insert.terminalMessage.customerQuery")
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.tabValidation()
                        }
                      }
                    },
                    [
                      _c("NextDetailPanel", {
                        attrs: { items: _vm.custSqlItems },
                        model: {
                          value: _vm.form.FieldAnalysisCustSqls,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "FieldAnalysisCustSqls", $$v)
                          },
                          expression: "form.FieldAnalysisCustSqls"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ef690a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ef690a6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FieldAnalysis/update.vue
// module id = null
// module chunks = 